export const languages = ['EN', 'AR', 'CA', 'CS', 'DE', 'EL', 'ES', 'FI', 'HE', 'HU', 'IS', 'IT', 'KO', 'NL', 'SK', 'SV', 'NB', 'DA', 'PL', 'FR', 'PT', 'SL']
